import React from "react";
import { NavLink } from "react-router-dom";

const NavigationMenu = ({ title, links }) => {
  const commonClasses = "flex items-center p-3 rounded-lg font-semibold w-full transition-colors duration-150";

  const getLinkClasses = ({ isActive }) => {
    if (isActive) {
      return `${commonClasses} bg-blue-100 text-blue-800`;
    } else {
      return `${commonClasses} text-gray-700 hover:bg-gray-200`;
    }
  };

  return (
    <div className="mb-8">
      <h2 className="text-xs font-semibold text-gray-400 mb-4 uppercase">
        {title}
      </h2>
      <nav className="flex flex-col space-y-2">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={getLinkClasses}
            end
          >
            {link.icon}
            {link.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default NavigationMenu;
